module.exports = __webpack_public_path__ + "img/siping.67635853.gif";